// removed by extract-text-webpack-plugin
module.exports = {"sidebar-item":"sidebar-item__1ly22","sidebar-item--active":"sidebar-item--active__3rIVf","sidebar-container":"sidebar-container__2s9E2","arrow":"arrow__2eWTh"};


//////////////////
// WEBPACK FOOTER
// ./styles/home/sidebar.scss
// module id = 740
// module chunks = 68